<template>
  <p id="introduce_content" v-if="introduceData != null" v-html="introduceData.desc"></p>
</template>

<script>
export default {
  name: "ProfileDetail",
  data() {
    return {
      title: '协会简介',
    }
  },
  computed: {
    // setIntroduce
    introduceData() {
      return this.$store.state.introduceData;
    },
  },
  mounted() {
  },
  methods: {

  }
}
</script>

<style scoped>

  #introduce_content {
    /*background-color: yellow;*/
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/introduce/ProfileDetail.vue